import { ListItemIcon, MenuItem, MenuList } from '@mui/material';
import { Popup } from '@vis.gl/react-maplibre';

import MarkerDestination from '@/assets/icons/map/route-locations/destination.svg?react';
import MarkerOrigin from '@/assets/icons/map/route-locations/origin.svg?react';
import { Geocoder } from '@/modules/Geocoder';
import { useRoutesStore } from '@/stores/useRoutesStore';
import { RouteLocationType } from '@/types/RouteLocationType';

interface ContextPopUpProps {
  longitude?: number;
  latitude?: number;
  onClose: () => void;
}

export function ContextMenuMarker({ longitude, latitude, onClose }: ContextPopUpProps) {
  const { updateRouteLocations } = useRoutesStore((state) => state.actions);

  return longitude !== undefined && latitude !== undefined ? (
    <Popup closeOnClick closeOnMove closeButton={false} latitude={latitude} longitude={longitude} onClose={onClose}>
      <MenuList>
        {[
          { Icon: MarkerOrigin, label: 'Start setzen', routeLocationType: RouteLocationType.ORIGIN },
          { Icon: MarkerDestination, label: 'Ziel setzen', routeLocationType: RouteLocationType.DESTINATION },
        ].map(({ Icon, label, routeLocationType }) => (
          <MenuItem
            key={routeLocationType}
            sx={{ color: (theme) => theme.palette.text.secondary }}
            onClick={async () => {
              updateRouteLocations({
                location: await Geocoder.reverse({ type: 'Point', coordinates: [longitude, latitude] }),
                routeLocationType,
              });

              onClose();
            }}
          >
            <ListItemIcon sx={{ marginRight: 2 }}>
              <Icon />
            </ListItemIcon>
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Popup>
  ) : null;
}
